import * as React from "react";
import { Button } from "@/shared/components/atoms/button";
import { cn } from "@/shared/lib/utils";

const actionVariantClasses: Record<TableActionVariant, string> = {
  delete: "text-destructive hover:text-destructive hover:bg-destructive/10",
  edit: "text-green-600 hover:text-green-700 hover:bg-green-50 dark:text-green-500 dark:hover:text-green-400 dark:hover:bg-green-950/30",
  view: "text-muted-foreground hover:text-primary",
  default: "",
};

export type TableActionVariant = "delete" | "edit" | "view" | "default";

export interface TableActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: TableActionVariant;
  /** Prefer size="icon" for icon-only actions in tables */
  size?: "default" | "sm" | "lg" | "icon";
}

/**
 * Use for table row action buttons so icon colors are consistent across the app:
 * - delete: red (destructive)
 * - edit: muted, hover foreground
 * - view: muted, hover primary
 * - default: no extra styling
 */
const TableActionButton = React.forwardRef<
  HTMLButtonElement,
  TableActionButtonProps
>(function TableActionButton(
  { variant = "default", size = "icon", className, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      variant="ghost"
      size={size}
      className={cn(actionVariantClasses[variant], className)}
      {...props}
    />
  );
});

export { TableActionButton };
